import React, { useState, useEffect, useRef } from 'react';
import { BsWhatsapp, BsFacebook, BsInstagram } from 'react-icons/bs';

const socialLinks = [
  { name: 'WhatsApp', url: 'https://wa.me/+96103580388', icon: <BsWhatsapp className="text-white transform scale-125 text-lg" /> },
  { name: 'Facebook', url: 'https://www.facebook.com/profile.php?id=61574414203065&mibextid=ZbWKwL', icon: <BsFacebook className="text-white transform scale-125 text-lg" /> },
  { name: 'Instagram', url: 'https://www.instagram.com/restaurantabbas', icon: <BsInstagram className="text-white transform scale-125 text-lg" /> },
];

const MenuTab = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);
  const [animate, setAnimate] = useState(false);
  const menuButtonRef = useRef(null);
  const dropdownRef = useRef(null);

  const toggleMenu = () => {
    if (!isOpen) {
      setShouldRender(true);
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      const handleClickOutside = (event) => {
        // Check if click is outside both menu button and dropdown
        if (
          menuButtonRef.current &&
          !menuButtonRef.current.contains(event.target) &&
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setIsOpen(false);
        }
      };

      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [isOpen]);

  useEffect(() => {
    if (shouldRender && isOpen) {
      requestAnimationFrame(() => { setAnimate(true) });
    }
    if (!isOpen && shouldRender) {
      setAnimate(false);
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen, shouldRender]);

  return (
    <div className="relative">
      {/* Menu Button */}
      <div
        ref={menuButtonRef}
        className="flex flex-col items-end w-[50px] gap-[0.385rem] hover:cursor-pointer hover:opacity-60 transition-all"
        onClick={toggleMenu}
      >
        <span className="h-1 w-[80%] bg-dark dark:bg-light rounded-full"></span>
        <span className="h-1 w-full bg-dark dark:bg-light rounded-full"></span>
        <span className="h-1 w-[90%] bg-dark dark:bg-light rounded-full"></span>
      </div>

      {/* Dropdown menu */}
      {shouldRender && (
        <ul
          ref={dropdownRef}
          className={`bg-gold-dark absolute right-0 mt-2 w-fit flex flex-col gap-2 rounded-lg shadow-lg p-2 transition-all duration-300
            ${animate ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-5'}`}
        >
          {socialLinks.map(({ name, url, icon }) => (
            <li
              key={name}
              className="flex items-center font-sans p-2 hover:opacity-50 rounded-md cursor-pointer transition-all"
            >
                <a href={url} target="_blank" rel="noopener noreferrer"> {icon} </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MenuTab;